import { axiosInstance } from '../App';

const BASE = '/api/secured/patients';

export interface ScoreItem {
  scoreId: number;
  determinationId: number | null;
  description: string;
  unit: string | null;
  numeric: boolean;
}

export interface ScoreValue {
  date: string | null;
  value: number | null;
  observation: string | null;
}

export interface ReferenceHighlight {
  minValue: number | null;
  maxValue: number | null;
  drawLineMin: boolean;
  drawLineMax: boolean;
  color: string | null;
}

export async function getScoreDeterminations(patientId: number): Promise<ScoreItem[]> {
  const { data } = await axiosInstance.get<ScoreItem[]>(
    `${BASE}/${patientId}/score-history/scores`,
  );
  return data;
}

export async function getScoreValues(
  patientId: number,
  scoreId: number,
  determinationId: number | null,
): Promise<ScoreValue[]> {
  const params: Record<string, string | number> = { scoreId };
  if (determinationId != null) params.determinationId = determinationId;
  const { data } = await axiosInstance.get<ScoreValue[]>(
    `${BASE}/${patientId}/score-history/values`,
    { params },
  );
  return data;
}

export async function getReferenceHighlights(
  patientId: number,
  scoreId: number,
): Promise<ReferenceHighlight[]> {
  const { data } = await axiosInstance.get<ReferenceHighlight[]>(
    `${BASE}/${patientId}/score-history/highlights`,
    { params: { scoreId } },
  );
  return data;
}
